import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import SystemFlowSection from "./components/SystemFlowSection";
import IndustriesSection from "./components/IndustriesSection";
import CaseStudiesPreview from "./components/CaseStudiesPreview";
import HomeCtaSection from "./components/HomeCtaSection";

const HomePage = () => {
  return (
    <div className="bg-black min-h-screen" style={{ fontFamily: "Arial, sans-serif" }}>
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <SystemFlowSection />
      <IndustriesSection />
      <CaseStudiesPreview />
      <HomeCtaSection />
      <Footer />
    </div>
  );
};

export default HomePage;
